import type { CSSProperties } from 'react'
import { WEB_ASSETS } from '@tenfour/contracts'
import s from './BrandLockup.module.css'

type BrandLockupProps = {
  className?: string
  /** Accessible name. Use null when an ancestor already supplies the name. */
  label?: string | null
  /** The text height; the icon and gap scale with it. */
  size?: CSSProperties['fontSize']
  tone?: 'default' | 'inverse'
}

/** Canonical app lockup: the solid-orange spiral followed by live Inter text. */
export function BrandLockup({
  className,
  label = 'Ten Four',
  size,
  tone = 'default',
}: BrandLockupProps) {
  const style = size
    ? ({ '--brand-lockup-size': typeof size === 'number' ? `${size}px` : size } as CSSProperties)
    : undefined

  return (
    <span
      className={[s.lockup, tone === 'inverse' ? s.inverse : '', className ?? '']
        .filter(Boolean)
        .join(' ')}
      style={style}
      data-brand-lockup
      role={label ? 'img' : undefined}
      aria-label={label ?? undefined}
      aria-hidden={label ? undefined : true}
    >
      <img src={WEB_ASSETS.brand.favicon} alt="" className={s.icon} aria-hidden />
      <span className={s.text}>tenfour</span>
    </span>
  )
}
